import React, { useState, useRef, useEffect } from 'react';
import {
  Grid,
  Divider,
  Typography,
  TextField,
  FormLabel,
  Box,
  FormControl,
  Select,
  FormHelperText,
  MenuItem,
  Alert,
  Container,
  Card,
  CardContent
} from '@mui/material';
import { useFormik, Form, FormikProvider } from 'formik';
import * as Yup from 'yup';
import { useBusinessEntityState, useHttpApi, useAppState, useCoreTableState } from 'state';
import { LoadingButton } from '@mui/lab';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router';
import Page from 'components/Page';
import AllDocSubTypes from 'components/DocMangement/AllDocSubTypes';

const AddDocSubType = () => {
  const { addDocumentSubType } = useHttpApi();
  const { fetchAllDocumentTypes, allDocumentTypes, fetchAllDocumentSubTypes } =
    useBusinessEntityState();
  const { enqueueSnackbar } = useSnackbar();
  const { throwErrorMessage } = useAppState();
  const [error, setError] = useState('');
  const CreteDocSubTypeSchema = Yup.object().shape({
    doc_sub_type_name: Yup.string().required('Document Sub Type Name is required'),
    doc_type_id: Yup.string().required('Document Type is required')
  });

  const formik = useFormik({
    initialValues: {
      doc_sub_type_name: '',
      doc_type_id: ''
    },
    validationSchema: CreteDocSubTypeSchema,
    onSubmit: async (data, { resetForm }) => {
      try {
        console.log('Check', data);
        const res = await addDocumentSubType(data);
        resetForm();
        await fetchAllDocumentSubTypes();
        enqueueSnackbar('Acceptable Document added Succesfully!', { variant: 'success' });
      } catch (e) {
        throwErrorMessage(e);
      }
    }
  });

  const fetchData = async () => {
    const _fetchAllDocumentTypes = async () => {
      await fetchAllDocumentTypes();
    };
    _fetchAllDocumentTypes();
  };

  useEffect(() => {
    fetchData();
  }, []);

  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } = formik;

  return (
    <>
      <Page title="Document Sub Type">
        <Container sx={{ my: 2 }}>
          <Card>
            {error && (
              <Box mb={4}>
                <Alert severity="error">{error}</Alert>
              </Box>
            )}

            <Container>
              <Grid
                conatiner
                spacing={2}
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  mt: 2
                }}
              >
                <Grid item lg={5} md={12} sm={12} xs={12}>
                  <Typography
                    sx={{
                      fontSize: '1.125rem',
                      fontWeight: 'bold',
                      mt: 4,
                      mb: 1,
                      ml: 4
                    }}
                  >
                    Add Document Sub Type
                  </Typography>

                  <FormikProvider value={formik}>
                    <Form autoComplete="off" onSubmit={handleSubmit}>
                      <CardContent sx={{ ml: 2, mr: 2 }}>
                        <Grid item lg={12} md={6} sm={12} xs={12}>
                          <FormLabel>Enter Document Sub Type</FormLabel>
                          <TextField
                            sx={{ mt: 1.5 }}
                            fullWidth
                            size="small"
                            autoComplete="off"
                            type="text"
                            {...getFieldProps('doc_sub_type_name')}
                            error={Boolean(touched.doc_sub_type_name && errors.doc_sub_type_name)}
                            helperText={touched.doc_sub_type_name && errors.doc_sub_type_name}
                          />
                        </Grid>
                        <Grid item lg={12} md={6} sm={12} xs={12} sx={{ mt: 1 }}>
                          <FormLabel>Associate with a Document Type</FormLabel>

                          <FormControl size="small" variant="outlined" fullWidth sx={{ mt: 1 }}>
                            <Select
                              displayEmpty
                              inputProps={{ 'aria-label': 'Without label' }}
                              {...getFieldProps('doc_type_id')}
                              error={Boolean(touched.doc_type_id && errors.doc_type_id)}
                              helperText={touched.doc_type_id && errors.doc_type_id}
                            >
                              {allDocumentTypes.map((t) => (
                                <MenuItem key={t.id} value={t.id}>
                                  {t.name}
                                </MenuItem>
                              ))}
                            </Select>
                            <FormHelperText sx={{ color: '#d32f2f' }}>
                              {touched.doc_type_id && errors.doc_type_id}
                            </FormHelperText>
                          </FormControl>
                        </Grid>
                        <Grid item lg={12} md={6} sm={12} xs={12}>
                          <LoadingButton
                            sx={{
                              width: '8rem',
                              height: '2.5rem',
                              mt: 4
                            }}
                            variant="gradient"
                            loadingPosition="start"
                            id="create-token"
                            type="submit"
                          >
                            Add
                          </LoadingButton>
                        </Grid>
                      </CardContent>
                    </Form>
                  </FormikProvider>
                </Grid>
                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{
                    backgroundColor: '#f5f8fa',
                    border: '2px solid #f5f8fa',
                    mb: 2
                  }}
                />
                <Grid item lg={7} md={12} sm={12} xs={12}>
                  <Typography
                    sx={{
                      fontSize: '1.125rem',
                      fontWeight: 'bold',
                      mt: 4,
                      mb: 1,
                      ml: 4
                    }}
                  >
                    View Document Sub Types
                  </Typography>

                  <CardContent sx={{ ml: 2, mr: 2 }}>
                    <AllDocSubTypes />
                  </CardContent>
                </Grid>
              </Grid>
            </Container>
          </Card>
        </Container>
      </Page>
    </>
  );
};

export default AddDocSubType;
